import { motion } from "framer-motion";

// Subtle animated PCB / circuit line SVG for dark section backgrounds.
export function CircuitBg({ className = "", opacity = 0.5 }) {
  const paths = [
    "M0 80 H140 L180 120 H320 L360 80 H520",
    "M0 200 H90 L130 160 H260 L300 200 H460 L500 240 H640",
    "M640 60 H520 L480 100 H360",
    "M0 320 H180 L220 280 H380 L420 320 H600",
  ];
  const nodes = [
    [140, 80], [320, 120], [520, 80], [90, 200], [260, 160],
    [460, 200], [640, 200], [520, 60], [180, 320], [380, 280], [600, 320],
  ];
  return (
    <svg
      className={className}
      viewBox="0 0 640 400"
      fill="none"
      preserveAspectRatio="xMidYMid slice"
      style={{ opacity }}
      aria-hidden="true"
    >
      {paths.map((d, i) => (
        <motion.path
          key={i}
          d={d}
          stroke="#00B9E8"
          strokeWidth="1"
          initial={{ pathLength: 0, opacity: 0 }}
          whileInView={{ pathLength: 1, opacity: 0.6 }}
          viewport={{ once: true }}
          transition={{ duration: 2.2, ease: "easeInOut", delay: i * 0.25 }}
        />
      ))}
      {nodes.map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r="3" fill="#00B9E8" className="node-pulse"
          style={{ animationDelay: `${i * 0.3}s` }} />
      ))}
    </svg>
  );
}
